"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var DiscountLabelTitle_1 = require("./discountLabel/DiscountLabelTitle");
var DiscountPriceValue_1 = require("./discountPriceValue/DiscountPriceValue");
var PriceDisplayType_1 = require("../../../../../common/enum/PriceDisplayType");
var Discount = function (_a) {
    var currency = _a.currency, discount = _a.discount, label = _a.label, boldPrice = _a.boldPrice, boldLabel = _a.boldLabel, id = _a.id;
    var _b;
    var price = discount.values.find(function (price) { return price.currency === currency; });
    return (<core_1.Grid container={true} justifyContent={'space-between'} data-test={"summary:car_details:discount_" + id}>
      <DiscountLabelTitle_1.default label={label} boldLabel={boldLabel}/>
      <DiscountPriceValue_1.default price={(_b = price) === null || _b === void 0 ? void 0 : _b.amount} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={currency} boldPrice={boldPrice} showSign={true}/>
    </core_1.Grid>);
};
exports.default = Discount;
